import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@material-ui/core';
import ReactEcharts from "echarts-for-react";

function ItemsGraph(props) {
    const { data } = props;
    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'clientProfileScreen' });
    const showVertically = useMediaQuery("(max-width:600px)");

    const option = useMemo(() => {
        if (!data || !data.length) return;

        const categoryAxis = {
            type: 'category',
            axisLabel: { show: false },
            axisTick: { show: false },
        }
        const valueAxis = { type: 'value' }

        let xAxis, yAxis, encode, grid;
        if (showVertically) {
            xAxis = { ...valueAxis, position: 'top' }
            yAxis = categoryAxis
            encode = { x: 'quantity', y: 'name' }
            grid = { left: 4, top: 28, right: 12, bottom: 0 }
        } else {
            xAxis = categoryAxis
            yAxis = valueAxis
            encode = { x: 'name', y: 'quantity' }
            grid = { left: 32, top: 16, right: 0, bottom: 4 }
        }

        const option = {
            grid,
            xAxis,
            yAxis,
            dataset: {
                source: data,
                dimensions: ['name', 'quantity'],
            },
            encode,
            series: [
                {
                    name: 'Items',
                    type: 'bar',
                    barWidth: 28,
                    itemStyle: {
                        color: '#00a4e0'
                    },
                    label: {
                        show: true,
                        rotate: showVertically ? 0 : 90,
                        position: showVertically ? [4, 0] : [0, '97%'],
                        verticalAlign: 'bottom',
                        formatter: '{b}',
                        fontSize: 14,
                        fontWeight: 'bold',
                    }
                }
            ],
            tooltip: {
                trigger: 'axis',
                formatter: (params) => `${params[0].value.name}: <strong>${params[0].value.quantity}</strong>`
            },
        };
        return option;
    }, [data, showVertically])

    return (
        <div className="dashboardView-card cdbp-items" >
            <p className="dashboardView-card-title">{t("mostPurchasedItems")}</p>

            {
                option
                    ? <ReactEcharts
                        option={option}
                        style={{ height: '100%' }}
                    />
                    : <p>N/D</p>
            }
        </div>
    )
}

export default ItemsGraph